import KeyValueObjectMapper from '@/utils/key-value-object-mapper.js';

const imageSortByWeight = (images) => {
  return images?.sort((a, b) => {
    if (a.weight > b.weight) {
      return 1;
    } else if (a.weight < b.weight) {
      return -1;
    }
    return 0;
  });
};

const productDataMapper = (data) => {
  if (Array.isArray(data?.assetImageList)) {
    data.images = KeyValueObjectMapper(data.assetImageList);
  }
  if (data?.variants) {
    data.variants.forEach((variant) => {
      let attributes = {};
      if (Array.isArray(variant?.variantAttributes)) {
        attributes = KeyValueObjectMapper(variant.variantAttributes);
        variant.variantAttributes = attributes;
      }
    });
  }

  return data;
};

export {imageSortByWeight, productDataMapper};
